import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[80vh] text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-20 h-20 rounded-full bg-background-100 flex items-center justify-center mx-auto mb-4">
          <i className="ri-error-warning-line text-foreground-400 text-3xl"></i>
        </div>
        <h1 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mt-6">此页面尚未创建</h1>
        <p className="mt-2 text-sm text-foreground-500">{location.pathname}</p>
        <p className="mt-4 text-foreground-600">该页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-6 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}